import React from 'react';
import ContractFullDTO from 'features/contracts/dtos/ContractFullDTO';
import ContractEnergyDTO from 'features/contracts/dtos/ContractEnergyDTO';
import ContractDetailLayoutPage from './ContractDetailLayoutPage';
import RolesChecker from 'features/customer/components/RolesChecker';
import { getContractDetailRootRoute } from 'features/shared/helpers/routeHelper';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import ReservedCapacityGasFormSection from 'features/requirements/sections/requirementFormTypes/reservedCapacityGas/ReservedCapacityGasFormSection';
import { useTranslation } from 'react-i18next';
import { isEnabledCustomForm } from 'features/requirements/helpers/requirementTypeHelper';


type Props = {
  contract: ContractFullDTO;
  contractEnergy: ContractEnergyDTO;
}

const ChangeReservedCapacityGas = ({ contract, contractEnergy }: Props) => {
  // translations
  const tModules = useTranslation("shared\\moduleNames").t;
  const tLabels = useTranslation(["contracts\\contracts"]).t;

  // render
  return (
    <ContractDetailLayoutPage
      contract={contract}
      contractEnergy={contractEnergy}
      links={[
        { text: tModules("reservedCapacityPage.title"), to: getContractDetailRootRoute(contract.contractId!, "reserved-capacity") },
        { text: tModules("changeReservedCapacityPage.title") }
      ]}
    >
      <RenderWrapper isVisible={() => isEnabledCustomForm("ZMENAKAPACITYPLYN")}>
        <RolesChecker enabledRoles="Contributor">
          <ReservedCapacityGasFormSection 
            selectedContractId={contract.contractId}
            sendButtonTitle={tLabels("changeReservedCapacityPage.changeCapacity")}
            useOutsideOfRequirements
          />
        </RolesChecker>
      </RenderWrapper>
    </ContractDetailLayoutPage>
  )
}

export default ChangeReservedCapacityGas;